import React, { Component } from 'react';
import { connect } from 'react-redux';
import { VoiceLogsAction } from '../../actions';
import { CardBody, Card, CardHeader, Input, Button } from 'reactstrap';
import { TableLoader } from '../../../components/Loaders';
import Pagination from "react-js-pagination";
import moment from 'moment'



class VoiceLogs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			keywords: '',
			page: {
				activePage: 1,
				perPage: 20,
				totalItemsCount: 0
			}
		};
		this.getVoiceLogsData = this.getVoiceLogsData.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSearch = this.handleSearch.bind(this);

	}

	componentDidMount() {
		this.getVoiceLogsData();
	}

	getVoiceLogsData() {
		const { dispatch } = this.props;
		const { page  ,keywords  } = this.state;
		let dataToSend = {
			active_page: page.activePage,
			per_page: page.perPage , 
			keywords : keywords
		};
		dispatch(VoiceLogsAction.getVoiceLogData(dataToSend));
	}

	handlePageChange(pageNumber) {
		const { page } = this.state;
		page.activePage = pageNumber;
		this.setState({ page }, () => this.getVoiceLogsData());
	}

	componentWillReceiveProps(props) {
		let { page, activeTab } = this.state;
		page.totalItemsCount = 0;
		if (props.logs) {
			page.totalItemsCount = props.logs.total_records;
		}
		if (props.activeTab) {
			activeTab = props.activeTab;
		}
		this.setState({
			page,
			activeTab
		});
	}

	handleChange(e) {
		const { name, value } = e.target

		this.setState({
			...this.state, [name]: value
		})
	}
	
	handleSearch(e) {
		const { page } = this.state

		this.setState({
			...this.state, page: {
				...page, activePage: 1
			}
		}, () => this.getVoiceLogsData())
	}


	render() {
		const { logs, loading } = this.props;
		const { page  , keywords } = this.state;
		return (
			<Card>
				<CardHeader>
					<i className="fas fa-envelope" />
					<strong>Voice Logs</strong>
				</CardHeader>
				<CardBody>
					<div className="d-flex mb-2 " >
						<Input name='keywords' className='w-25 mr-2' value={keywords} onChange={this.handleChange} placeholder='Search...' />
						<Button color='primary' onClick={this.handleSearch}>
							Search
						</Button>
					</div>
					{loading ? (
						<TableLoader />
					) : (
						<React.Fragment>
							<div className="table-responsive-sm  animated fadeIn">
								<table className="table table-sm table-condensed table-striped table-bordered table-outline">
									<thead className="thead-light">
										<tr>
											<th>#</th>
											<th>Sent By Company</th>
											<th>Mobile</th>
											<th>Call Text</th>
											<th>Credit Used</th>
											<th>status</th>
											<th>Report</th>
											<th>Sent At</th>
											<th>Delivered At</th>

										</tr>
									</thead>
									<tbody>
										{logs && logs.voice_list && logs.voice_list.length ? (
											logs.voice_list.map(function (eachData, index) {
												return (
													<React.Fragment>
														<tr>
															<td>{(page.activePage - 1) * page.perPage + index+1}</td>
															<td>{eachData.sender.name}</td>
															<td>{eachData.receiver_mobile}</td>
															<td>{eachData.message}</td>
															{/* <td>{eachData.balance_log[0].deducted_balance}</td> */}
															<td>{'-'}</td>
															<td>{eachData.status}</td>
															<td>{eachData.report}</td>
															<td>{eachData.created_at ? moment(eachData.created_at).format('DD/MM/YYYY hh:mm:ss A') : '-'}</td>
															<td>{eachData.connect_time ? moment(eachData.connect_time).format('DD/MM/YYYY hh:mm:ss A') : '-'}</td>
														</tr>
													</React.Fragment>
												);
											})
										) : (
											<tr>
												<td colSpan="4" className="text-center">
													No Data Found
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							{page.totalItemsCount <= page.perPage ? (
								''
							) : (
								<Pagination
									activePage={page.activePage}
									itemsCountPerPage={page.perPage}
									totalItemsCount={page.totalItemsCount}
									pageRangeDisplayed={5}
									linkClass="page-link"
									itemClass="page-item"
									onChange={this.handlePageChange}

								/>
							)}
						</React.Fragment>
					)}
				</CardBody>
			</Card>
		);
	}
}

function mapStateToProps(state) {
	const { loading, data } = state.getVoiceLogsData;
	return {
		loading,
		logs: data,
	};
}

const connectedVoiceLogs = connect(mapStateToProps)(VoiceLogs);
export { connectedVoiceLogs as VoiceLogs };

